import { weappSDK } from '../sdk/index';
import { ua } from '../ua';

// 处理飞书、钉钉使用原生window.open相关打开逻辑
export const registerSdkpen = () => {
  const originOpen = window?.open;
  window.originOpenFnc = originOpen;
  const openFunc: any = (url?: string, name?: string, specs?: string) => {
    if (/Lark/.test(ua.browser) || /DingTalk/.test(ua.browser)) {
      try {
        weappSDK
          .checkApi('openLink')
          .then(() => {
            weappSDK
              .exec('openLink', {
                url, // 要打开的链接地址
                openType: 3, // 可选 打开方式 1:客户端当前窗口 2: 客户端新窗口（只针对飞书、企业微信pc客户端生效） 3:系统默认浏览器 默认：3
              })
              .then((res: any) => {})
              .catch((res: any) => {
                // 执行openLink失败   屏蔽原因openType = 3 的时候 云桥默认处理 会使用location.href 替换地址 无需我们兜底处理。 云桥会处理
                // originOpen(url, name, specs);
              });
          })
          .catch(() => {
            // checkApi过程中失败
            originOpen(url, name, specs);
          });
      } catch (error) {
        originOpen(url, name, specs);
      }
      return;
    }
  };
  window.open = openFunc;
  // 返回卸载函数
  return () => {
    window.open = originOpen;
  };
};

